<template>
  <div>
    <section-header heading="2" ja="推奨環境"/>
    <div class="textArea">
      <p>プリクラONは以下の環境を推奨環境としています。全ての端末、環境での動作を保証するものではありません。</p>
      <template v-if="isIOS">
        <p>
          ■アプリ版<br>
          iPhone： iOS13以上<br>
          ※詳しくは各ストアにてご確認ください。
        </p>
        <p>
          ■Web版<br>
          iPhone： iOS13以上<br>
          ※標準ブラウザでの利用を推奨いたします。
        </p>
      </template>
      <template v-else>
        <p>
          ■アプリ版<br>
          Android： 9.0以上(一部端末を除く)<br>
          ※詳しくは各ストアにてご確認ください。
        </p>
        <p>
          ■Web版<br>
          Android： 9.0以上<br>
          ※標準ブラウザでの利用を推奨いたします。
        </p>
      </template>
    </div>
    <sub-btn @click="onAboutWeb()">プリクラONについてに戻る</sub-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import SubBtn from '@/components/SubBtn.vue'
import { isIOS } from "../assets/js/util"

export default {
  name: "AboutWeb01",
  components: {
    SectionHeader,
    SubBtn
  },
  data () {
    return { isIOS: null }
  },
  mounted() {
    this.isIOS = isIOS();
  },
  methods: {
    onAboutWeb() {
      this.$router.push("/AppaboutWeb")
    }
  }
}
</script>

<style lang="scss" scoped>
.textArea {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
  p {
    margin-top: 1em;
  }
}
</style>
